import { IS_PRODUCTION_MODE } from '~/constants';
export const FORM_DATA = {
    dmid: 'aGFnb2NvODk4OEB3dXphay5jb20=',
    email: '',
    list_id: IS_PRODUCTION_MODE ? '42391' : '210906',
};
export const FORM_URL = 'https://forms.dmsubscribe.ru/';
export const MODAL_TITLE = 'Мы почти закончили!';
export const MODAL_TEXT = `Вы подписались на нашу рассылку. Теперь вам необходимо подтвердить вашу подписку. На ваш email отправлено письмо с подтверждением. Для завершения подписки пройдите, пожалуйста, по ссылке в этом письме.`;
